import React, { useEffect, useRef, useCallback } from "react";

interface PrimaryPaginationProps {
  inputdata: {
    isFirst: boolean;
    isLast: boolean;
    pageNumber: number;
    pageSize: number;
  } | null;
  totalitems: number;
  rowsperpage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<any>>;
  setPageSize: React.Dispatch<React.SetStateAction<any>>;
}

const AuiPrimaryPagination: React.FC<PrimaryPaginationProps> = ({
  inputdata,
  totalitems,
  rowsperpage,
  setCurrentPage,
  setPageSize,
}) => {
  const paginationRef = useRef<HTMLDivElement | null>(null);

  const PageChange = useCallback(
    (event: any) => {
      event.preventDefault();
      const newPageNumber = event.detail;
      setCurrentPage(newPageNumber);
    },
    [setCurrentPage]
  );

  const handlePaginationChange = useCallback(
    (event: any) => {
      event.preventDefault();
      const newPageSize = event.detail.value;
      setPageSize(newPageSize);
    },
    [setPageSize]
  );

  const handlePaginationClick = useCallback((event: any) => {
    event.preventDefault();
  }, []);

  useEffect(() => {
    const paginationElement = paginationRef.current;

    paginationElement?.addEventListener("auiPageChange", PageChange);

    paginationElement?.addEventListener(
      "auiPaginationChange",
      handlePaginationChange
    );

    paginationElement?.addEventListener(
      "auiPaginationClick",
      handlePaginationClick
    );

    return () => {
      paginationElement?.removeEventListener("auiPageChange", PageChange);
      paginationElement?.removeEventListener(
        "auiPaginationChange",
        handlePaginationChange
      );
      paginationElement?.removeEventListener(
        "auiPaginationClick",
        handlePaginationClick
      );
    };
  }, [PageChange, handlePaginationChange, handlePaginationClick]);

  return (
    <div ref={paginationRef}>
      <aui-itemspagination
        inputdata={JSON.stringify(inputdata)}
        totalitems={totalitems}
        rowsperpage={rowsperpage}
      ></aui-itemspagination>
    </div>
  );
};

export default AuiPrimaryPagination;
